import React from 'react'
import PropTypes from 'prop-types'
import Media from 'components/common/Media'
import Portal from 'components/common/Portal/Portal'
import { VerticalSeparator } from 'components/common/Separator/Separator'

const BOTMyStoreDetails = ({
  storeDetails: {
    storeId,
    storeNumber,
    address,
    address: {
      address1,
      city,
      zipcode
    } = {}
  } = {}
}) =>
  address ?
    <React.Fragment>
      <Portal id="BOTMyStoreDetailsOnPromoPageSeparator">
        <VerticalSeparator margin="0 0 0 -11px" />
      </Portal>
      <Media.Desktop>
        <Portal id="BOTMyStoreDetailsOnPromoPage">
          Offers for { address1 } { city } { zipcode }
        </Portal>
      </Media.Desktop>
      <Media.Mobile>
        <Portal id="BOTMyStoreDetailsOnPromoPage">
          My Store
        </Portal>
      </Media.Mobile>
    </React.Fragment>
    : null


BOTMyStoreDetails.propTypes = {
  storeDetails: PropTypes.shape({
    address: PropTypes.shape(),
    SAPStoreNumber: PropTypes.string,
    storeDetailsUrl: PropTypes.string,
    storeId: PropTypes.string,
    storeImages: PropTypes.arrayOf(),
    storeNumber: PropTypes.string
  })
}

BOTMyStoreDetails.type = 'BOTMyStoreDetails'

export default BOTMyStoreDetails
